import { useState } from "react";

import { trackSearchFilterCategoryState } from "@javascript/helpers/searchFilterUtilities";

import Accordion, { AccordionContent, AccordionTrigger } from "@javascript/reactComponents/lds/accordion/Accordion";
import Chip from "@javascript/reactComponents/lds/chips/Chip";
import Divider from "@javascript/reactComponents/lds/Divider";

import FilterItem from "@javascript/reactComponents/lds/FilterItem";
import Heading from "@javascript/reactComponents/lds/typography/Heading";
import Icon from "@javascript/reactComponents/lds/Icon";

function UserListFilterItem({ index, list, selectedListId }) {
  const handleSelect = (list) =>
    FacetSearchListActions.toggleList(list, { doSearch: true });

  const isSelected = selectedListId === list._id

  return (
    <FilterItem
      id={"list_holder_entry_" + index}
      key={list._id}
      label={list.name}
      leadingContent={
        <Icon
          id={"list_radio_" + list._id}
          name="radio"
          filled={isSelected}
        />
      }
      onLeadingContentClick={() => handleSelect(list)}
      selected={isSelected}
    />
  );
}

/**
 * Allows the user to filter events based on lists.
 * Will trigger a new facet search on change.
 *
 * @component
 *
 * */
function UserListsSelectorInner({ lists, selectedListId }) {
  const [open, setOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const DISPLAY_LIMIT = 10;

  const trailingAction = (
    <>
      <div className="flex-grow-1" />
      <Chip
        label=""
        selected={open}
        size="small"
        leadingIcon={`chevron-${open ? "up" : "down"}-centered`}
        variant={open ? "primary" : "secondary"}
      />
    </>
  );

  const handleAccordionToggle = () => {
    trackSearchFilterCategoryState(!open, "user_lists");
    setOpen(!open)
  };

  const renderFooter = () => {
    if (lists.length > DISPLAY_LIMIT && !showAll) {
      return (
        <p id="list_show_all" className="type-body-medium">
          <a
            className="lds-text-link show_more_link"
            id="list_more"
            onClick={() => setShowAll(true)}
          >
            Show All
          </a>
        </p>
      );
    }
    return null;
  };

  const displayedLists = showAll ? lists : lists.slice(0, DISPLAY_LIMIT);

  return (
    <Accordion open={open} className="filter_category">
      <AccordionTrigger className="cursor-pointer" onClick={handleAccordionToggle}>
        <Heading
          id="list_props"
          leadingIcon="list"
          size="h3"
          tooltip="Filter events based on the lists a selected company is on."
          trailingAction={trailingAction}
        >
          {Zymewire.facet_search_filters.user_lists}
        </Heading>
      </AccordionTrigger>
      <AccordionContent gap="var(--filter-category-space-gap)">
        <div id="list_holder" className="filter_category_inner">
          {displayedLists.map((list, index) => (
            <UserListFilterItem key={list._id} index={index} list={list} selectedListId={selectedListId} />
          ))}
          {renderFooter()}
        </div>
      </AccordionContent>
    </Accordion>
  );
}

const UserListSelector = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, function (data) {
      return data.userLists;
    }),
  ],
  getInitialState() {
    return FacetSearchUserListSlice;
  },
  UNSAFE_componentWillMount: function() {
    $.getJSON("/facet_search/user_company_list_details", function (data) {
      FacetSearchListActions.setListOfUsersLists(data);
    });
  },
  render: function () {
    const { lists, selected } = this.state;
    const selectedListId = selected && (selected.orgListId || selected.userListId)

    if (!Zymewire.user.feature_tags.includes("lists")) {
      return null;
    }

    return (
      <>
        <Divider className="facet-search-section-divider" size="small" variant="secondary" />
        <UserListsSelectorInner lists={lists} selectedListId={selectedListId} />
      </>
    );
  },
});

window.UserListSelector = UserListSelector;
export default UserListSelector;
